import { render, staticRenderFns } from "./list-receipts.vue?vue&type=template&id=9abd4a14&scoped=true"
import script from "./list-receipts.vue?vue&type=script&lang=js"
export * from "./list-receipts.vue?vue&type=script&lang=js"
import style0 from "./list-receipts.vue?vue&type=style&index=0&id=9abd4a14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9abd4a14",
  null
  
)

export default component.exports